import { createPortal } from 'react-dom';
import styles from './ModalBackdrop.module.css';

/**
 * The shared dimmer for modals. Always mounted; CSS reveals it whenever a
 * non-floating dialog is open. It sits below the whole modal band. Portaled to
 * <body> so its z-index shares the modals' stacking context.
 */
export function ModalBackdrop() {
  return createPortal(<div className={styles.backdrop} />, document.body);
}
